import {
  Card,
  DataStatus,
  Form,
  FormButton,
  FormField,
  FormSubmitHandler,
  showNotification,
} from 'platform/components';
import {Grid, Right, Space, Text} from 'platform/foundation';
import {object} from 'yup';

import {useGetTipcarsPlatformQuery, useTipcarsAuthenticateMutation} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {yupString} from 'shared/web';

type PlatformAuthenticationFormTipCarsData = {
  companyCode: string;
  password: string;
};

export function PlatformAuthenticationFormTipCars() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isFetching, isError} = useGetTipcarsPlatformQuery({params});
  const [saveAuthentication] = useTipcarsAuthenticateMutation();

  const onSubmitCredentials: FormSubmitHandler<PlatformAuthenticationFormTipCarsData> = (
    values,
    _setErrors,
    reset
  ) =>
    saveAuthentication({body: values, params})
      .unwrap()
      .then(() => {
        showNotification.success(
          i18n.t('entity.advertisingPlatforms.notifications.credentialsSaved')
        );
        reset(undefined, {keepValues: true});
      })
      .catch(handleApiError);

  return (
    <Card title={i18n.t('general.labels.authentication')}>
      <Text size="small" color="secondary">
        {i18n.t('page.settings.labels.authenticationDescription')}
      </Text>
      <Space vertical={4} />

      <DataStatus isLoading={isFetching} isError={isError} minHeight={25}>
        <Form<PlatformAuthenticationFormTipCarsData>
          values={data?.credentials}
          schema={schema}
          onSubmit={onSubmitCredentials}
          shouldWatchForUnsavedChanges
        >
          {(control) => (
            <>
              <Grid columns={2}>
                <FormField
                  control={control}
                  name="companyCode"
                  type="text"
                  label={i18n.t('page.advertisement.labels.companyCode')}
                />
                <FormField
                  control={control}
                  name="password"
                  type="password"
                  label={i18n.t('general.labels.password')}
                />
              </Grid>

              <Space vertical={4} />
              <Right>
                <FormButton
                  control={control}
                  type="submit"
                  title={i18n.t('general.actions.save')}
                />
              </Right>
            </>
          )}
        </Form>
      </DataStatus>
    </Card>
  );
}

const schema = object({
  companyCode: yupString.required(),
  password: yupString.required(),
});
